import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Guards the Attendance & Leave module. Users with the
 * "Show in Attendance and Leave" toggle off (showInAttendance === false)
 * are redirected to the dashboard, even when navigating directly by URL.
 */
export const AttendanceRoute: React.FC = () => {
  const { currentUser } = useAuth();

  if (!currentUser) {
    return null;
  }

  if (currentUser.showInAttendance === false) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};
